/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CostAnomalySpendTrendByResourceIdWidgetConfiguration extends models.BaseChartWidgetConfigurationModel {
    constructor() {
        super();
        this.setDiscriminator("CostAnomalySpendTrendByResourceIdWidgetConfiguration");
    }

    getFixupPrototypeFunction() { return CostAnomalySpendTrendByResourceIdWidgetConfiguration.fixupPrototype; }

    static newInstance(model: Partial<CostAnomalySpendTrendByResourceIdWidgetConfiguration>): CostAnomalySpendTrendByResourceIdWidgetConfiguration {
        let obj = Object.assign(new CostAnomalySpendTrendByResourceIdWidgetConfiguration(), model);
        CostAnomalySpendTrendByResourceIdWidgetConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CostAnomalySpendTrendByResourceIdWidgetConfiguration>): CostAnomalySpendTrendByResourceIdWidgetConfiguration {
        if (!model) return null;
        return CostAnomalySpendTrendByResourceIdWidgetConfiguration.newInstance(<CostAnomalySpendTrendByResourceIdWidgetConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CostAnomalySpendTrendByResourceIdWidgetConfiguration) {
        if (!obj) return;

        models.CostAnomalySpendTrendByResourceIdWidgetConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CostAnomalySpendTrendByResourceIdWidgetConfiguration): boolean {
        if (models.BaseChartWidgetConfigurationModel.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, CostAnomalySpendTrendByResourceIdWidgetConfiguration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
